import React, { useEffect } from 'react';

import GlobalSearch, { IGlobalSearch, IGlobalSearchResultGroup, IGlobalSearchSuggestionGroup } from './index';

export interface IGlobalSearchModalProps extends IGlobalSearch {
  show?: boolean;
  title?: string;
  onClose?: () => void;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  globalSearchStyle?: React.CSSProperties;
}

const GlobalSearchModal = (props: IGlobalSearchModalProps) => {
  const { show, onClose, title, style, contentStyle, globalSearchStyle, ...rest } = props;
  if (!show) return null;
  /**
   * 绑定escape事件，按下esc键时关闭搜索弹窗
   */
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);
  return (
    <div className="odc-doc-search-portal" style={style}>
      <div className="search-portal-mask" onClick={onClose}></div>
      <div className="search-portal-content" style={contentStyle}>
        {title && <p className="search-portal-title">{title}</p>}
        <GlobalSearch
          {...rest}
          style={globalSearchStyle}
        />
      </div>
    </div>
  );
};

export default GlobalSearchModal;